import { useUser } from "@js/apps/common/hooks";
import type { FreelancerBidListItem, Job } from "@js/types/jobs";

import { JobDetailsActionBar } from "../job-details-action-bar";

import { JobDetailsHeader } from "./job-details-header";

type JobHeaderProps = {
  job: Job;
  bid?: FreelancerBidListItem;
};

export const JobHeader = ({ job, bid }: JobHeaderProps) => {
  const user = useUser();
  if (!job) {
    return <></>;
  }

  return (
    <div>
      {user && <JobDetailsActionBar job={job} />}
      <JobDetailsHeader job={job} bid={bid} />
    </div>
  );
};
